// import React, { Component } from "react";
import { Container } from "reactstrap";
import { Route, Routes, Navigate } from "react-router-dom";
import DocumentTitle from "react-document-title";
import Home from "./Components/Home";
import Login from "./Components/Login";
import { connect } from "react-redux";
import Callback from "./Components/Callback";
import ErrorBoundary from "./Components/Error/ErrorBoundary";
import AccessDenied from "./Components/Error/AccessDenied";
import Header from "./Components/Header/Header";
import AppInfo from "./Components/AppInfo";
import ViewSearch from "./Components/User/View/ViewSearch";
import { hasPrivilege } from "../src/Components/Utils/utils";
import RequestList from "../src/Components/User/ReviewRequest/RequestList";
import ResetSearch from "../src/Components/User/ResetPassword/ResetSearch";
import ModifySearch from "./Components/User/Modify/ModifySearch";
import CreateUser from "./Components/User/Create/CreateUserForm";
import Footer from "../src/Components/Footer/Footer";
import AdminForm from "../src/Components/Admin/AdminForm";
import ViewSearchAdmin from "./Components/Admin/View/ViewAdminSearch";
import ModifyAdminSearch from "./Components/Admin/Modify/ModifyAdminSearch";
import RejectedList from "../src/Components/User/RejectedRequest/RejectedList";
import GenerateReport from "../src/Components/User/GenerateReport/GenerateReport";
import InternalUserForm from "./Components/User/Create/InternalUserForm";
import { menu_privileges } from "./Components/Constants/static";
const App = (props) => {
  const { token, userPoolRoles, pool, superAdmin, internalApp } = props;
  const ProtectedRoute = ({
    component: Component,
    privileges: requiredPrivileges = [],
    privilegeNotRequired = false,
    superAdminAllowed = false,
    ...rest
  }) => {
    return token && (pool || superAdminAllowed) ? (
      <ErrorBoundary>
        {privilegeNotRequired ||
        (requiredPrivileges &&
          hasPrivilege(userPoolRoles, requiredPrivileges, superAdmin)) ? (
          <Component {...props} />
        ) : (
          <AccessDenied />
        )}
      </ErrorBoundary>
    ) : (
      <Navigate to="/" />
    );
  };

  return (
    <DocumentTitle title="Doorkeeper">
      <Container fluid className="wrapper">
        <Header />
        <AppInfo />
        <Container fluid className="containerHeight">
          <Routes>
            <Route
              exact
              path="/"
              element={token ? <Home /> : <Login />}
              // render={(props) =>
              //   token ? <Home {...props} /> : <Login {...props} />
              // }
            />
            <Route path="/callback" element={<Callback></Callback>}></Route>
            <Route
              path="/modify/*"
              element={
                <ProtectedRoute
                  path="/modify/*"
                  component={!internalApp ? CreateUser : InternalUserForm}
                  privileges={menu_privileges["modify"]}
                />
              }
            ></Route>
            <Route
              path="/create"
              element={
                <ProtectedRoute
                  path="/create"
                  component={!internalApp ? CreateUser : InternalUserForm}
                  privileges={menu_privileges["create"]}
                />
              }
            ></Route>

            <Route
              path="/modify"
              element={
                <ProtectedRoute
                  path="/modify"
                  component={ModifySearch}
                  privileges={menu_privileges["modify"]}
                />
              }
            ></Route>

            <Route
              path="/view"
              element={
                <ProtectedRoute
                  path="/view"
                  component={ViewSearch}
                  privileges={menu_privileges["view"]}
                />
              }
            ></Route>

            <Route
              path="/review"
              element={
                <ProtectedRoute
                  path="/review"
                  component={RequestList}
                  privileges={menu_privileges["review"]}
                />
              }
            ></Route>

            <Route
              path="/rejectedlist"
              element={
                <ProtectedRoute
                  path="/rejectedlist"
                  component={RejectedList}
                  privileges={menu_privileges["reapprove"]}
                />
              }
            ></Route>

            <Route
              path="/reset"
              element={
                <ProtectedRoute
                  path="/reset"
                  component={ResetSearch}
                  privileges={menu_privileges["reset"]}
                />
              }
            ></Route>

            <Route
              path="/createadmin"
              element={
                <ProtectedRoute
                  path="/createadmin"
                  component={AdminForm}
                  privileges={menu_privileges["manageAdmin"]}
                  superAdminAllowed={superAdmin}
                />
              }
            ></Route>

            <Route
              path="/viewadmin"
              element={
                <ProtectedRoute
                  path="/viewadmin"
                  component={ViewSearchAdmin}
                  privileges={menu_privileges["manageAdmin"]}
                  superAdminAllowed={superAdmin}
                />
              }
            ></Route>

            <Route
              path="/modifyadmin/*"
              element={
                <ProtectedRoute
                  path="/modifyadmin/*"
                  component={AdminForm}
                  privileges={menu_privileges["manageAdmin"]}
                  superAdminAllowed={superAdmin}
                />
              }
            ></Route>

            <Route
              path="/modifyadmin"
              element={
                <ProtectedRoute
                  path="/modifyadmin"
                  component={ModifyAdminSearch}
                  privileges={menu_privileges["manageAdmin"]}
                  superAdminAllowed={superAdmin}
                />
              }
            ></Route>

            <Route
              path="/report"
              element={
                <ProtectedRoute
                  path="/report"
                  component={GenerateReport}
                  privileges={menu_privileges["generateReport"]}
                />
              }
            ></Route>
          </Routes>
        </Container>
        <Footer />
      </Container>
    </DocumentTitle>
  );
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
  userPoolRoles: state.pool.userPoolRoles,
  pool: state.pool.userPool,
  superAdmin: state.account.superAdmin,
  internalApp: state.pool.internalApp,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(App);
